import { render, staticRenderFns } from "./AllActivities.vue?vue&type=template&id=50497c50&scoped=true&"
import script from "./AllActivities.vue?vue&type=script&lang=js&"
export * from "./AllActivities.vue?vue&type=script&lang=js&"
import style0 from "./AllActivities.vue?vue&type=style&index=0&id=50497c50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50497c50",
  null
  
)

export default component.exports